import { call, put, select, takeLatest } from 'redux-saga/effects';

import { environment } from 'environments/environment';
import { CustomerDetail } from 'generated/bffCustomer/models';
import { ExtendedAxiosResponse } from 'helpers/apiClient';
import {
  AppAction,
  createActionType,
  createApiActionCreators,
  createReducer,
  RequestActionTypes,
} from 'helpers/redux/reduxHelpers';
import { AppState } from 'helpers/store/models/AppState';
import { ApiClientRequest } from 'models/ApiClientRequest';
import { CustomerInfo } from 'models/context/CustomerInfo';

import { getApiUrl, performApiCall } from 'saga/apiClient/ducks';
import { api } from 'saga/context/customer/api';
import { selectContextCustomerInfo } from 'saga/context/customer/ducks';

/* STATE */
export interface CustomerDetailState {
  customerDetail: CustomerDetail | null;
}

/* ACTION TYPES */
export enum CustomerDetailActionTypes {
  GetCustomerDetail = '@@Customer/GET_CUSTOMER_DETAIL',
}

/* ACTIONS */
export const getCustomerDetailActions = createApiActionCreators(CustomerDetailActionTypes.GetCustomerDetail);

/* REDUCERS */
const initialState: CustomerDetailState = {
  customerDetail: null,
};

export default createReducer(initialState.customerDetail, {
  [CustomerDetailActionTypes.GetCustomerDetail]: {
    [RequestActionTypes.SUCCESS]: (_state: CustomerDetail | null, payload: CustomerDetail) => payload,
    [RequestActionTypes.FAILURE]: () => null,
  },
});

/* SELECTORS */

export const selectCustomerDetail = (state: AppState) => state.customerDetail;

/* SAGAS */
function* getCustomerDetail({ payload: cuRefNo }: AppAction<string>) {
  const contextCustomer: CustomerInfo | null = yield select(selectContextCustomerInfo);

  if (!cuRefNo && !contextCustomer?.cuRefNo) {
    return;
  }

  const request: ApiClientRequest = {
    apiCall: call(
      api.getCustomer,
      yield getApiUrl(environment.urlConfig.customer),
      String(cuRefNo || contextCustomer?.cuRefNo)
    ),
  };
  const resp: ExtendedAxiosResponse = yield call(performApiCall, request);

  if (resp.ok) {
    yield put(getCustomerDetailActions.success(resp.data));
  } else {
    console.log('getCustomerDetail failure: api.getCustomer failed');
    yield put(getCustomerDetailActions.failure());
  }
}

/* EXPORT */
export function* customerDetailSaga() {
  yield takeLatest(
    createActionType(CustomerDetailActionTypes.GetCustomerDetail, RequestActionTypes.REQUEST),
    getCustomerDetail
  );
}
